$(document).ready(function() {
  jQuery(".filter-toggle").on("click" , function(e){
    e.preventDefault();
    jQuery(this).toggleClass("active");
    jQuery(".filter-toggle-wrap").slideToggle("is-visible");
  })
  var filter = jQuery(this).find('.full_width .sorting_wrapper');
  jQuery(this).find('.filter-toggle').insertBefore(filter);

  jQuery('.topbanner').prependTo('.pagecontent');
  jQuery('#shopify-section-footer-style-3,#shopify-section-footer-design-2, #shopify-section-footer-style-1').appendTo('.site-inner');

  jQuery('.tt-homeslider,.cmsrightbanner').wrapAll('<div class="slider-banner"><div class="container"><div class="row"></div></div></div>');

  if($('.shopify-section.index-section').hasClass('testimonial')){
    jQuery(".category-featured").addClass("col-sm-8");
    jQuery('.category-featured,.testimonial').wrapAll("<div class='ttcategory-testi'></div>");
  }
  else{
    jQuery(".tt-category-feature-wrap-inner").addClass("container");
  }

  jQuery('.category-featured,.testimonial').wrapAll("<div class='ttcategory-testi'></div>");  

  var p_col = jQuery('.ttcmscatbanner1').data('col');
  jQuery('.category-slider .category_slider_content').each(function(){  
    jQuery(this).find('contents #shopify-section-catsub-banner1--'+p_col+'').insertBefore('.tthometab-title');

  });
  //video
  var p = jQuery(".popup_overlay");
  jQuery(".play-icone").click(function() {
    jQuery("body").addClass("popup-toggle");
    p.css("display", "block");
  });
  p.click(function(event) {
    e = event || window.event;
    if (e.target == this) {
      jQuery(p).css("display", "none");
      jQuery('body').removeClass('popup-toggle'); 
    }
  });
  jQuery(".popup_close,.slides .slick-arrow").click(function() {
    p.css("display", "none");
    jQuery('body').removeClass('popup-toggle'); 
  });
  jQuery(".checkout-btn .shopify-payment-button").addClass("btn");
  //video popup
  function toggleVideo(state) {
    var div = document.getElementById("popupVid");
    var iframe = div.getElementsByTagName("iframe")[0].contentWindow;
    func = state == "hide" ? "pauseVideo" : "playVideo";
    iframe.postMessage(
      '{"event":"command","func":"' + func + '","args":""}',
      "*"
    );
  }
  jQuery("#popup_toggle").click(function() {
    p.css("visibility", "visible").css("opacity", "1");
  });
  var w_width = $(window).width();
  $('.slider-content-main-wrap').css('width',w_width);
  if($('.site-header').hasClass('header_transaparent')){
    $('body.template-index').addClass('header_transaparent')
  }
  var img_id = jQuery('.product-single__thumbs .slick-active.slick-current').find('.product-single__thumb').data('id');
  if(jQuery('.product-lightbox-btn').hasClass(img_id)){
    jQuery('.product-lightbox-btn.'+img_id).show();
  }
  jQuery(".filter-left").on("click" , function(e){
    e.preventDefault();
    jQuery(this).toggleClass("active");
    jQuery(".off-canvas.position-left").toggleClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").toggleClass("is-visible is-closable");
  });
  jQuery(".is-overlay-fixed").on("click" , function(e){
    e.preventDefault();
    jQuery(".filter-left").trigger('click');
    jQuery(".filter-right").trigger('click');
  });
  jQuery(".filter-right").on("click" , function(e){
    e.preventDefault();
    jQuery(this).toggleClass("active");
    jQuery(".off-canvas.position-right").toggleClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").toggleClass("is-visible is-closable");
  });
  jQuery(".off-canvas .sidebar_close").on("click" , function(e){
    e.preventDefault();
    jQuery(".off-canvas.position-left").removeClass("is-open");
    jQuery(".off-canvas.position-right").removeClass("is-open");
    jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass("is-visible is-closable");
  });
  $('.product-360-button a').magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    disableOn: false,
    preloader: false,
    fixedContentPos: false,
    callbacks: {
      open: function() {
        $(window).resize()
      }
    }
  });
  countDownIni('.flip-countdown,.js-flip-countdown'); 
  /** popup Video **/

  $('.popup-video').magnificPopup({
    disableOn: 300,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

  /***/

  if ($('a.product-lightbox-btn').length > 0 || $('a.product-video-popup').length > 0) {
    $('.product-single__photos .gallery,.design_2 .product-img').magnificPopup({
      delegate: 'a', // child items selector, by clicking on it popup will open
      type: 'image',
      tLoading: '<div class="please-wait dark"><span></span><span></span><span></span></div>',
      removalDelay: 300,
      closeOnContentClick: true,
      gallery: {
        enabled: true,
        navigateByImgClick: false,
        preload: [0, 1]
      },
      image: {
        verticalFit: false,
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
      },
      callbacks: {
        beforeOpen: function() {
          var productVideo = $('.product-video-popup').attr('href');
          if (productVideo) {
            this.st.mainClass = 'has-product-video';
            var galeryPopup = $.magnificPopup.instance;
            galeryPopup.items.push({
              src: productVideo,
              type: 'iframe'
            });
            galeryPopup.updateItemHTML();
          }
        },
        open: function() {}
      }
      // other options
    });
  }
  $('.design_3 .product-img,.design_5 .pro_img').magnificPopup({
    delegate: 'a', // child items selector, by clicking on it popup will open
    type: 'image',
    tLoading: '<div class="please-wait dark"><span></span><span></span><span></span></div>',
    removalDelay: 300,
    closeOnContentClick: true,
    gallery: {
      enabled: true,
      navigateByImgClick: false,
      preload: [0, 1]
    },
    image: {
      verticalFit: false,
      tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
    },
    callbacks: {
      beforeOpen: function() {
        var productVideo = $('.product-video-popup').attr('href');
        if (productVideo) {
          this.st.mainClass = 'has-product-video';
          var galeryPopup = $.magnificPopup.instance;
          galeryPopup.items.push({
            src: productVideo,
            type: 'iframe'
          });
          galeryPopup.updateItemHTML();
        }
      },
      open: function() {}
    }
    // other options
  });
  $('body').on('click', '.product-lightbox-btn', function(e) {
    $('.product-wrapper-owlslider').find('.owl-item.active a').click();
    e.preventDefault();
  });

  /* special-product product thumb img*/
  jQuery('.special-collection .product-single__thumbs a').on('click', function () {
    var src = jQuery(this).data("fullsrc");
    if (src != '') {
      jQuery(this).closest('.product-wrapper').find('img.grid-view-item__image').first().attr('src', src);
    }
    jQuery(this).parent('.grid-item').addClass('open').siblings('.grid-item').removeClass('open');
  });

  $('.qtyplus').on('click',function(e){
    e.preventDefault();     
    var  input_val = jQuery(this).parents('.qty-box-set').find('.quantity');
    var currentVal = parseInt( jQuery(this).parents('.qty-box-set').find('.quantity').val());
    if (!isNaN(currentVal)) {
      jQuery(this).parents('.qty-box-set').find('.quantity').val(currentVal + 1);
    } else {
      jQuery(this).parents('.qty-box-set').find('.quantity').val(1);
    }
  });

  $(".qtyminus").on('click',function(e) {
    e.preventDefault();
    var  input_val = jQuery(this).parents('.qty-box-set').find('.quantity');
    var currentVal = parseInt( jQuery(this).parents('.qty-box-set').find('.quantity').val());
    if (!isNaN(currentVal) && currentVal > 1) {
      jQuery(this).parents('.qty-box-set').find('.quantity').val(currentVal - 1);
    } else {
      jQuery(this).parents('.qty-box-set').find('.quantity').val(1);
    }

  });

  $("#navToggle").on('click',function(e) {
    jQuery(this).next('.Site-navigation').slideToggle(500);
  });
  $(".menu_toggle_wrap #navToggle").on('click',function(e) {
    jQuery(this).parent().next('.Site-navigation').slideToggle(500);
  });


  /*Scroll to top js*/
  jQuery("#GotoTop").on('click',function () {
    jQuery("html, body").animate({
      scrollTop: 0
    }, '1000');
    return false;
  });

  jQuery(".site-header__search.search-full .serach_icon").on('click',function(e){
    e.preventDefault();
    jQuery(this).toggleClass('active'); 
    jQuery('body').toggleClass('search_full_active'); 
    jQuery('.full-search-wrapper').addClass('search-overlap');
    jQuery('.header_3 .search-full-screen').addClass('active');
    jQuery(".search-bar > input").focus();
  });
  jQuery(".site-header__search.search-full .close-search").on('click',function(){
    jQuery('.site-header__search.search-full .serach_icon').removeClass('active');   
    jQuery('.full-search-wrapper').removeClass('search-overlap'); 
    jQuery('.header_3 .search-full-screen').removeClass('active');
    jQuery('body').removeClass('search_full_active'); 
  });
  jQuery(".myaccount  .dropdown-toggle").on('click',function(event){   
    event.preventDefault();
    jQuery('body').toggleClass('myaccount_active'); 
    jQuery('body').removeClass('language-open');
    jQuery('body').removeClass('cart_active');
    jQuery('body').removeClass('currency-open');
    jQuery( ".customer_account" ).slideToggle( "fast" );
    jQuery( ".currencies.flag-dropdown-menu" ).slideUp( "fast" );
    jQuery(this).toggleClass('open');
    jQuery('body').removeClass('search_full_active'); 
    jQuery('.site-header .site-header_cart_link').removeClass("active");
    jQuery( "#slidedown-cart" ).slideUp( "fast" );
    jQuery( "#Sticky-slidedown-cart" ).slideUp( "fast" );
    jQuery( ".header_language .disclosure-list" ).slideUp( "fast" );
  });
  $(".header_currency .currency_wrapper.dropdown-toggle").on("click", function (event) {     
    event.preventDefault();
    jQuery(".customer_account").stop(); 
    jQuery('body').toggleClass('currency-open');
    jQuery('body').removeClass('language-open');
    jQuery( "body" ).removeClass( 'myaccount_active' );
    jQuery('body').removeClass('cart_active');
    jQuery('.disclosure__toggle').removeClass('active');
    jQuery( ".currencies.flag-dropdown-menu" ).slideToggle( "fast" );
    $(this).toggleClass('active'); 
    jQuery( ".customer_account" ).slideUp( "fast" );
    jQuery( ".header_language .disclosure-list" ).slideUp( "fast" ); 
    jQuery( "#slidedown-cart" ).slideUp( "fast" );
    jQuery( "#Sticky-slidedown-cart" ).slideUp( "fast" );
  });

  $(".header_language .disclosure__toggle").on("click", function (event) {     
    event.preventDefault();
    jQuery(".customer_account").stop();    
    jQuery('body').toggleClass('language-open');
    jQuery('body').removeClass('currency-open');
    jQuery( "body" ).removeClass( 'myaccount_active' );
    jQuery('body').removeClass('cart_active');
    jQuery('.currency_wrapper').removeClass('active');
    jQuery( ".disclosure-list" ).slideToggle( "fast" );
    $(this).toggleClass('active');  
    jQuery( ".customer_account" ).slideUp( "fast" );
    jQuery( ".currencies.flag-dropdown-menu" ).slideUp( "fast" );
    jQuery( "#slidedown-cart" ).slideUp( "fast" );
    jQuery( "#Sticky-slidedown-cart" ).slideUp( "fast" );
  });
  //cms-block-banner



  if(jQuery("body").hasClass('left_sidebar') || jQuery("body").hasClass('right_sidebar')){
    $('body.left_sidebar #cmsblock-banner .blockbanner' || 'body.right_sidebar #cmsblock-banner .blockbanner').owlCarousel({
      items: 8,
      nav: false,
      dots: false,
      loop: false,
      autoplay: true,
      responsive: {
        1800: {
          items: 4
        },
        1200: {
          items: 4
        },
        1199: {
          items: 3
        },
        992: {
          items: 3
        },
        991: {
          items: 3
        },
        768: {
          items: 3
        },
        767: {
          items: 2
        },
        481: {
          items: 2
        },
        480: {
          items: 1
        },
        320: {
          items: 1
        },
        100: {
          items: 1
        }
      }
    });
  }else{
    $('body:not(.left_sidebar) #cmsblock-banner .blockbanner' || 'body:not(.right_sidebar) #cmsblock-banner .blockbanner').owlCarousel({
      items: 8,
      nav: false,
      dots: false,
      loop: false,
      autoplay: true,
      responsive: {
        1800: {
          items: 4
        },
        1200: {
          items: 4
        },
        1199: {
          items: 3
        },
        992: {
          items: 3
        },
        991: {
          items: 3
        },
        768: {
          items: 3
        },
        767: {
          items: 2
        },
        481: {
          items: 2
        },
        480: {
          items: 1
        },
        320: {
          items: 1
        },
        100: {
          items: 1
        }
      }
    });
  }  
  //ttcmssubbanner
  $('.ttcms-subbanner .ttbanner-wrap').owlCarousel({
    items :3, //1 items above 1000px browser width
    nav : false,
    dots : false,
    loop: false,
    autoplay:true,
    responsive: {
      992: {
        items: 3
      },
      481: {
        items: 2
      },
      100: {
        items:1
      }
    }
  });

  $(".full_gallery_slider.owl-carousel").on("changed.owl.carousel",function(e){
//     console.log(e);
    var element = e.target; // DOM element, in this example .owl-carousel
    var items = e.item.count; // Number of items
    var item = e.relatedTarget.relative(e.item.index) + 1; 

//     console.log(e.relatedTarget.relative);

    $(element).parent().find('.num').html(item + "/" + items)
  }),

    $('body:not(.rtl) .full_gallery_slider.owl-carousel').owlCarousel({
    stagePadding: 200,
    loop:true,
    startPosition:0,
    center: true,
    dots:true,
    items:2,
    lazyLoad: true,
    nav:false,
    responsive:{
      0:{
        items:1,
        stagePadding: 60
      },
      600:{
        items:1,
        stagePadding: 150
      },
      768:{
        items:1,
        stagePadding: 180
      },
      868:{
        items:1,
        stagePadding: 250
      },
      1800:{
        items:2,
        stagePadding: 300
      }
    }
  });
  $('body.rtl .full_gallery_slider.owl-carousel').owlCarousel({
    stagePadding: 200,
    loop:true,
    startPosition:0,
    center: true,
    dots:true,
    items:2,
    rtl:true,
    lazyLoad: true,
    nav:false,
    responsive:{
      0:{
        items:1,
        stagePadding: 60
      },
      600:{
        items:1,
        stagePadding: 150
      },
      768:{
        items:1,
        stagePadding: 180
      },
      868:{
        items:1,
        stagePadding: 250
      },
      1800:{
        items:2,
        stagePadding: 300
      }
    }
  });

  var p_col = jQuery('.slider-specialproduct').data('col');
  if(jQuery("body").hasClass('disable_menutoggle')){
    $('body.disable_menutoggle .slider-specialproduct').owlCarousel({
      items : 2, //10 items above 1000px browser width
      nav : true,
      dots : false,
      rewind:true,
      responsive: {
        100: {
          items: 1
        },
        320: {
          items: 1
        },
        481: {
          items: 1
        },
        992: {
          items: 2
        },
        1200: {
          items: 2
        }
      }
    });
  }else{
    $('body .slider-specialproduct').owlCarousel({
      items : 2, //10 items above 1000px browser width
      nav : true,
      dots : false,
      rewind:true,
      responsive: {
        100: {
          items: 1
        },
        320: {
          items: 1
        },
        481: {
          items: 1
        },
        992: {
          items: 2
        },
        1200: {
          items: 4
        }
      }
    });
  }
  if(jQuery("body").hasClass('left_sidebar') || jQuery("body").hasClass('right_sidebar')){
    $('body.left_sidebar .slider-specialproduct' || 'body.right_sidebar .slider-specialproduct').owlCarousel({
      items : 2, //10 items above 1000px browser width
      nav : true,
      autoplay:true,
      autoplaySpeed:1500,
      autoplayHoverPause: true,
      dots : false,
      responsive: {
        100: {
          items:1
        },
        768: {
          items: 1
        },
        1200: {
          items: 2
        }
      }
    });
  }else{
    $('body:not(.left_sidebar) .slider-specialproduct' || 'body:not(.right_sidebar) .slider-specialproduct').owlCarousel({
      items : 2, //10 items above 1000px browser width
      nav : true,
      dots : false,
      autoplay:true,
      autoplaySpeed:1500,
      autoplayHoverPause: true,
      responsive: {
        100: {
          items: 1
        },
        768: {
          items: 1
        },
        1200: {
          items: 2
        }
      }
    });
  }  
  $('.slider-specialproduct-wrap').each(function () { 
    if($(this).find('.owl-nav').hasClass('disabled')){
      $(this).find('.customNavigation').hide();
    }else{
      $(this).find('.customNavigation').show();
    }
  });
  $(".slider-specialproduct-wrap .customNavigation .next").click(function(){
    var wrap = $(this).closest('.slider-specialproduct-wrap');
    $(wrap).find('.slider-specialproduct').trigger('next.owl');
  });
  $(".slider-specialproduct-wrap .customNavigation .prev").click(function(){
    var wrap = $(this).closest('.slider-specialproduct-wrap');
    $(wrap).find('.slider-specialproduct').trigger('prev.owl');
  });


  /* special-product for style1 product thumb img*/
  jQuery('.special-collection .product-single__thumbs .product-img-dot').on('click', function () {
    var src = jQuery(".special-collection .product-single__thumbs .product-img-dot img").attr('src');
    if (src != '') {
      jQuery(this).closest('.product-wrapper').find('img.grid-view-item__image').first().attr('src', src);
    }
    jQuery(this).parent('.grid-item').addClass('open').siblings('.grid-item').removeClass('open');
  });

  $('body .special-product-div .product-image.style1').owlCarousel({
    items : 1, //1 items above 1000px browser width
    nav : false,
    dots : true,
    loop: false,
    autoplay:false,
    slideTransition: 'linear',
    responsive: {
      1279: {
        items: 1
      },
      600: {
        items: 1
      }
    }
  });
  $('.slider-specialproduct .product-wrapper,.product-single').each(function(){
    var $desc = $(this).find('.product-description .progress');
    var $qty = $(this).find('.quantity');
    var $pbar = $(this).find('.progress-bar');
    var $progress = $desc;
    var $progressBar = $pbar;
    var $quantity = $qty.html();
//     console.log($quantity);
    var currentWidth = parseInt($progressBar.css('width'));
    var allowedWidth = parseInt($progress.css('width'));
    var addedWidth = currentWidth + parseInt($quantity);
    if (addedWidth > allowedWidth) {
      addedWidth = allowedWidth;
    }
    var progress = (addedWidth / allowedWidth) * 100;
    $progressBar.animate({width: progress + '%' }, 100);
  });  

  var p_col = jQuery('.slider-bestproduct').data('col');
  $('body .slider-bestproduct').owlCarousel({
    items : p_col, //10 items above 1000px browser width
    nav : true,
    autoplay:false,
    autoplaySpeed:1500,	
    dots : false,
    responsive: {
      100: {
        items: 1
      },
      620: {
        items: 2
      },
      1200: {
        items: 3
      },
      1460: {
        items: 4
      },
      1700: {
        items: p_col
      }
    }
  });
  $('.slider-bestproduct-wrap').each(function () { 
    if($(this).find('.owl-nav').hasClass('disabled')){
      $(this).find('.customNavigation').hide();
    }else{
      $(this).find('.customNavigation').show();
    }
  });
  $(".slider-bestproduct-wrap .customNavigation .next").click(function(){
    var wrap = $(this).closest('.slider-bestproduct-wrap');
    $(wrap).find('.slider-bestproduct').trigger('next.owl');
  });
  $(".slider-bestproduct-wrap .customNavigation .prev").click(function(){
    var wrap = $(this).closest('.slider-bestproduct-wrap');
    $(wrap).find('.slider-bestproduct').trigger('prev.owl');
  });
  $('body .collection-desc-wrap .cat-banner').owlCarousel({
    items : 1, //1 items above 1000px browser width
    nav : false,
    dots : true,
    loop: false,
    autoplay:true,
    responsive: {
      1279: {
        items: 1
      },
      600: {
        items: 1
      }
    }
  });
  $('body .widget_top_rated_products .top-products').owlCarousel({
    items : 1, //1 items above 1000px browser width
    nav : true,
    dots : true,
    loop: false,
    autoplay:true,
    responsive: {
      1279: {
        items: 1
      },
      600: {
        items: 1
      }
    }
  });

  $('body .special-product-div .product-image.style1').owlCarousel({
    items : 1, //1 items above 1000px browser width
    nav : false,
    dots : true,
    loop: false,
    autoplay:false,
    slideTransition: 'linear',
    responsive: {
      1279: {
        items: 1
      },
      600: {
        items: 1
      }
    }
  });

  $('body #ttcmsservices .block_content').owlCarousel({
    items :4, //1 items above 1000px browser width
    nav : true,
    dots : true,
    loop: false,
    autoplay:true,
    rewindNav:true,
    responsive: {
      1200: {
        items: 4
      },
      700: {
        items: 3
      },
      481: {
        items: 2
      },
      100: {
        items: 1
      }
    }
  });

  $('body .tttestimonial-wrap .testimonials_wrap').owlCarousel({
    items: 1, //1 items above 1000px browser width
    nav: true,
    dots: false,
    loop: false,
    autoplay: false,
    autoplayHoverPause: false,
    responsive: {
      1279: {
        items: 1
      },
      1250: {
        items: 1
      },
      600: {
        items: 1
      }
    }
  });

  $(".tttestimonial-wrap .customNavigation .next").click(function(){
    var wrap = $(this).closest('.tttestimonial-wrap');
    $(wrap).find('.testimonials_wrap').trigger('next.owl');
  });
  $(".tttestimonial-wrap .customNavigation .prev").click(function(){
    var wrap = $(this).closest('.tttestimonial-wrap');
    $(wrap).find('.testimonials_wrap').trigger('prev.owl');
  });
  $('body #tt-megamenu .list_product_menu_content').owlCarousel({
    items : 3, //1 items above 1000px browser width
    nav : true,
    autoPlay:true,
    autoplaySpeed:1000,
    stopOnHover: false,
    loop: false,
    dots : true,
    responsive: {
      768: {
        items: 3
      },
      481: {
        items: 2
      },
      100: {
        items: 1
      }
    }
  });

  $('body:not(.both_sidebar) .category_cms_feature').owlCarousel({             
    nav : true,
    dots : false,
    autoplay:false,
    autoplaySpeed:1500,
    loop: false,
    responsive: {
      100: {
        items: 1
      },
      320: {
        items: 1
      },
      544: {
        items: 2
      },
      768: {
        items: 2
      },
      992: {
        items: 3
      },
      1200: {
        items: 3
      },
      1460: {
        items: 3
      }
    }
  });

  $('body.both_sidebar .category_cms_feature').owlCarousel({             
    nav : true,
    dots : false,
    autoplay:false,
    autoplaySpeed:1500,
    loop: false,
    responsive: {
      100: {
        items: 1
      },
      320: {
        items: 1
      },
      600: {
        items: 1
      },
      768: {
        items: 2
      },
      992: {
        items: 3
      },
      1200: {
        items: 2
      },
      1460: {
        items: 2
      }
    }
  });

  $('.category_feature_wrap').each(function () { 
    if($(this).find('.owl-nav').hasClass('disabled')){
      $(this).find('.customNavigation').hide();
    }else{
      $(this).find('.customNavigation').show();
    }
  });
  $(".category_feature_wrap .customNavigation .next").click(function(){
    var wrap = $(this).closest('.category_feature_wrap');
    $(wrap).find('.category_cms_feature').trigger('next.owl');
  });
  $(".category_feature_wrap .customNavigation .prev").click(function(){
    var wrap = $(this).closest('.category_feature_wrap');
    $(wrap).find('.category_cms_feature').trigger('prev.owl');
  }); 


  //abc

  $('body .header_2 .contact-discount .info').owlCarousel({
    items: 2,
    nav: false,
    dots: false,
    loop: false,
    autoplay: true,
    responsive: {
      1800: {
        items: 2
      },
      1550: {
        items: 2
      },
      100: {
        items: 1
      }
    }
  });

  $('body .header_1 .contact-discount .info').owlCarousel({
    items: 2,
    nav: false,
    dots: false,
    loop: false,
    autoplay: true,
    autoplaySpeed:1500,
    autoplayHoverPause: true,
    responsive: {
      1800: {
        items: 2
      },

      1700: {
        items: 2
      },
      1600: {
        items: 2
      },
      1460: {
        items: 2
      },
      100: {
        items: 1
      }
    }
  });

  $('body .header_3 .contact-discount .information').owlCarousel({
    items: 2,
    nav: false,
    dots: false,
    loop: false,
    autoplay: true,
    autoplaySpeed:1500,
    autoplayHoverPause: true,
    responsive: {
      1800: {
        items: 2
      },

      1700: {
        items: 2
      },
      1600: {
        items: 2
      },
      1599: {
        items: 2
      },
      1550: {
        items: 1
      },
      1460: {
        items: 1
      },
      100: {
        items: 1
      }
    }
  });
  var brandsowl = $("body #brands_list_slider");
  brandsowl.owlCarousel({
    items : 6 , //10 items above 1000px browser width
    dots: false,
    loop: false,
    autoplay:true,
    autoplaySpeed:1500,
    autoplayHoverPause: true,
    nav: true,
    responsive: {
      100: {
        items: 2
      },
      320: {
        items: 2
      },
      481: {
        items: 3
      },
      768: {
        items: 4
      },
      1200: {
        items: 5
      },
      1630: {
        items: 6
      }
    }
  });

  $('.brand-bar').each(function () { 
    if($(this).find('.owl-nav').hasClass('disabled')){
      $(this).find('.customNavigation').hide();
    }else{
      $(this).find('.customNavigation').show();
    }
  });
  $(".brands .customNavigation .next").click(function(){
    var wrap = $(this).closest('.brands');
    $(wrap).find('.tt-brand_slider').trigger('next.owl');
  });
  $(".brands .customNavigation .prev").click(function(){
    var wrap = $(this).closest('.brands');
    $(wrap).find('.tt-brand_slider').trigger('prev.owl');
  });

  $(".quick-view-wrap .btn,.product-wrapper .add_tocart .btn").click(function(){$(this).addClass("loading");setTimeout(function(){$(".quick-view-wrap .btn,.product-wrapper .add_tocart .btn").removeClass("loading")},2000)});

  if($('body:not(.template-index) .site-header .toggle_menu').hasClass('current-close')) {
    $('.tt-mega_menu').slideUp("2000");
  }
  $('.toggle_menu').click(function() {
    if($(this).hasClass('default-open') && $(window).width() < 992){
      if($(this).hasClass('current-close')) {
        $(this).addClass("current-open");
        $('body').addClass("menu-current-open");
        $(this).removeClass("current-close");
        $('.tt-mega_menu').slideToggle("2000");
      } else {
        $(this).removeClass("default-open");
        $(this).addClass("current-open");
        $('body').addClass("menu-current-open");
        $(this).removeClass("current-close");
        $('.tt-mega_menu').slideToggle("2000");
      }    
    }else if($(this).hasClass('default-open')){
      if($(this).hasClass('current-close')) {
        $(this).addClass("current-open");
        $('body').addClass("menu-current-open");
        $(this).removeClass("current-close");
        $('.tt-mega_menu').slideToggle("2000");
      } else if($(this).hasClass('current-open')) {
        $(this).addClass("current-close");
        $(this).removeClass("current-open");
        $('body').removeClass("menu-current-open");
        $('.tt-mega_menu').slideToggle("2000");
      }
    }
    else{
      if($(this).hasClass('current-open')) {
        $(this).addClass("current-close");
        $('body').removeClass("menu-current-open");
        $(this).removeClass("current-open");
        $('.tt-mega_menu').slideToggle("2000");
      } else{
        $(this).addClass("current-open");
        $(this).removeClass("current-close");
        $('body').addClass("menu-current-open");
        $('.tt-mega_menu').slideToggle("2000");
      }
    }
    if($(this).hasClass('default-open') && !$('.sticky_header').hasClass('fixed')) {
      $(this).addClass("current-close");
      $(this).removeClass("default-open");
      $('.tt-mega_menu').slideToggle("2000");
    }	
    if($(this).hasClass('default-open') && $('.sticky_header').hasClass('fixed')) {
      $(this).addClass("current-open");
      $('body').addClass("menu-current-open");
      $(this).removeClass("default-open");
      $('.tt-mega_menu').slideDown("2000");
    }
  });

});


function moremenu() {     
  {
    var max_elem = 4;      
  }
  var items = $(".top #accessibleNav > li");
  var surplus = items.slice(max_elem, items.length);
  surplus.wrapAll('<li class="more_menu site-nav--has-dropdown menu-item-depth-0"><ul class="top-link sub-nav__dropdown sub-menu mobile-nav__sublist">');
  jQuery('.more_menu').prepend('<a href="#" class="level-top topmega-menu-link">More</a>');
  jQuery('.more_menu').mouseover(function(){
    jQuery(this).children('ul').addClass('shown-link');
    jQuery('body').addClass('menu-open');
  })
  jQuery('.more_menu').mouseout(function(){
    jQuery(this).children('ul').removeClass('shown-link');
    jQuery('body').removeClass('menu-open');      
  });
  $(".topmenu #accessibleNav").css('display', 'block');
}
jQuery(document).ready(function(){
  moremenu();
});

jQuery(window).scroll(function () {
  if(jQuery(document).height() > jQuery(window).height()){
    var scroll = jQuery(window).scrollTop();
    if (scroll > 100) {
      jQuery("#GotoTop").fadeIn();
    } else {
      jQuery("#GotoTop").fadeOut();
    }
  }
});

function responsiveMenu(){
  if(jQuery(window).width() < 992) {    
    jQuery(".Site-navigation").insertAfter( ".nav-toggle" );
    jQuery('.sub-nav__dropdown').css('display','none');    
  }
  else{
    jQuery(".Site-navigation").appendTo( ".menu_wrapper" );  	 
  } 

  if(jQuery(window).width() < 992) {
    $('.header_style_1 #shopify-section-TT-mega_menu,.header_style_2 #shopify-section-TT-mega_menu,.header_style_3 #shopify-section-TT-mega_menu').appendTo('.ttresponsive_menu');
    $('#accessibleNav').appendTo('#tt-megamenu .tt_menus_ul');
    $('.header_2 .contact-discount ').appendTo('.header_2 .tt-mega_menu');
    $('.header_1 .contact-discount ').appendTo('.header_1 .tt-mega_menu');
    jQuery('.header_1 .site-header__search').insertAfter('.header_1 .center_header_1 .header_logo_wrap');
    jQuery('.header_1 .myaccount-cart').insertAfter('.header_1 #shopify-section-TT-mega_menu');
    $('.header_3 .contact-discount ').appendTo('.header_3 #accessibleNav');
    jQuery('.header_3 .myaccount-cart').insertAfter('.header_3 #tt-megamenu');
  }
  else{
    jQuery('#shopify-section-TT-megamenu').prependTo('.menu-block .container');
    $('#tt-megamenu .tt_menus_ul #accessibleNav').appendTo('.top');
    $('.header_2 .contact-discount ').insertAfter('.header_2 .center_header_2 .service-search');
    jQuery('.header_1 .site-header__search').insertAfter('.header_1 #shopify-section-TT-mega_menu');
    jQuery('.header_1 .myaccount-cart').insertAfter('.header_1 .center_header_1 .contact-discount');
    jQuery('.header_1 .contact-discount').insertAfter('.header_1 .offer-banner');
    $('.header_3 .contact-discount ').insertAfter('.header_3 .top');
    jQuery('.header_3 .myaccount-cart').insertAfter('.header_3 .site-header__search');
  }
}
jQuery(document).ready(function() {
  responsiveMenu();
  jQuery(".product-write-review").on('click',function(e) {
    e.preventDefault();
    $('a[href=\'#tab-2\']').trigger('click');
    jQuery('html, body').animate({
      scrollTop: jQuery(".product_tab_wrapper").offset().top-150
    }, 1000);
  });
});
jQuery(document).load(function() { 
});
jQuery(window).resize(function() {
  responsiveMenu();
  var w_width = $(window).width();
  $('.slider-content-main-wrap').css('width',w_width);
});

function footerToggle() {
  if(jQuery( window ).width() < 1200) {
    jQuery('.both_sidebar #column-left').insertAfter('#content,.collection_wrapper');
    jQuery('.both_sidebar .sidebar#column-left .collection_sidebar').insertAfter('.filter-wrapper');
    jQuery(".both_sidebar .sidebar-block .widget > h4,.both_sidebar #column-left.sidebar .widget > h4,.both_sidebar #column-right.sidebar .widget > h4,.both_sidebar .right-sidebar.sidebar .widget > h4,.both_sidebar .left-sidebar.sidebar .widget > h4,.blog-section .sidebar .widget > h4").addClass( "toggle" );
    jQuery(".both_sidebar .sidebar-block .widget,.both_sidebar #column-left.sidebar .widget ,.both_sidebar #column-right.sidebar .widget,.both_sidebar .right-sidebar.sidebar .widget,.both_sidebar .left-sidebar.sidebar .widget,.blog-section .sidebar .widget").children(':nth-child(2)').css( 'display', 'none' );
    jQuery(".both_sidebar .sidebar-block .widget.active,.both_sidebar #column-left.sidebar .widget.active,.both_sidebar #column-right.sidebar .widget.active,.both_sidebar .right-sidebar.sidebar .widget.active,.both_sidebar .left-sidebar.sidebar .widget.active,.blog-section .sidebar .widget.active").children(':nth-child(2)').css( 'display', 'block' );
    jQuery(".both_sidebar .sidebar-block .widget > h4.toggle,.both_sidebar #column-left.sidebar .widget > h4.toggle,.both_sidebar #column-right.sidebar .widget > h4.toggle,.both_sidebar .right-sidebar.sidebar .widget > h4.toggle,.both_sidebar .left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle").unbind("click");
    jQuery(".both_sidebar .sidebar-block .widget > h4.toggle,.both_sidebar #column-left.sidebar .widget > h4.toggle,.both_sidebar #column-right.sidebar .widget > h4.toggle,.both_sidebar .right-sidebar.sidebar .widget > h4.toggle,.both_sidebar .left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle").on('click',function() {
      jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle( "fast" );
    });  
  }
  else{
    jQuery('.both_sidebar #column-left').insertBefore('#content,.collection_wrapper');
    jQuery('.both_sidebar .collection_sidebar').prependTo('.left_column-wrap');
    jQuery(".both_sidebar .widget > h4").unbind("click");
    jQuery(".both_sidebar .widget > h4").removeClass( "toggle" );
    jQuery(".both_sidebar .widget").children(':nth-child(2)').css( 'display', 'block' );
  }
  if(jQuery( window ).width() < 992) {
    if($('.left-sidebar-menu').length > 0){
      jQuery('.left-sidebar-menu').appendTo('.ttresponsive_menu');
      jQuery('.header-right').appendTo('.ttresponsive_menu');
      jQuery(".ttresponsive_menu h4.widget-title").unbind("click");
      jQuery(".ttresponsive_menu  h4.widget-title").on('click',function() {
        jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle( "fast" );          
      }); 
    }else{
      jQuery('nav#menu .nav-menu-wrapper').appendTo('.ttresponsive_menu');
      jQuery(".nav-menu-wrapper h4.widget-title").unbind("click");
      jQuery(".nav-menu-wrapper h4.widget-title").on('click',function() {
        jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle( "fast" );
      }); 
    }

    jQuery('.left_sidebar #column-left').insertAfter('#content');
    if(jQuery('.site-footer').hasClass('fixed_footer'))  {
      jQuery('.page-wrapper').css('margin-bottom','0px');
    }
    jQuery('.left-sidebar.sidebar,.left_sidebar .left-sidebar.sidebar').insertAfter('.collection_wrapper, .content-wrapper');
    jQuery('.sidebar .sidebar-block').insertAfter('.filter-wrapper');
    jQuery('.sidebar#column-left .collection_sidebar').insertAfter('.filter-wrapper');
    jQuery(".site-footer .widget h5").addClass( "toggle" );
    jQuery(".site-footer .widget").children(':nth-child(2)').css( 'display', 'none' );
    jQuery(".site-footer .widget.active").children(':nth-child(2)').css( 'display', 'block' );
    jQuery(".site-footer .widget h5.toggle").unbind("click");
    jQuery('.footer-model-3 .footer-center-content .footer-about-wrap').prependTo('.footer-top');
    jQuery('.footer-model-3 .footer-top .contactus').prependTo('.footer-center-content');
    jQuery(".site-footer .widget h5.toggle").on('click',function() {
      jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle( "fast" );
    });   
    jQuery("#column-left.sidebar .widget > h4,#column-right.sidebar .widget > h4,.right-sidebar.sidebar .widget > h4,.left-sidebar.sidebar .widget > h4,.blog-section .sidebar .widget > h4").addClass( "toggle" );
    jQuery("#column-left.sidebar .widget ,#column-right.sidebar .widget,.right-sidebar.sidebar .widget,.left-sidebar.sidebar .widget,.blog-section .sidebar .widget").children(':nth-child(2)').css( 'display', 'none' );
    jQuery("#column-left.sidebar .widget.active,#column-right.sidebar .widget.active,.right-sidebar.sidebar .widget.active,.left-sidebar.sidebar .widget.active,.blog-section .sidebar .widget.active").children(':nth-child(2)').css( 'display', 'block' );
    jQuery("#column-left.sidebar .widget > h4.toggle,#column-right.sidebar .widget > h4.toggle,.right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle").unbind("click");
    jQuery("#column-left.sidebar .widget > h4.toggle,#column-right.sidebar .widget > h4.toggle,.right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle").on('click',function() {
      jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle( "fast" );
    });   
    jQuery(".left-sidebar .sidebar-block .widget > h4,.right-sidebar .sidebar-block .widget > h4,.collection_right .sidebar-block .widget > h4,.collection_left .sidebar-block .widget > h4,.filter-toggle-wrap .sidebar-block .widget > h4,.content-right .sidebar-block .widget > h4").addClass( "toggle" );
    jQuery(".left-sidebar .sidebar-block .widget,.right-sidebar .sidebar-block .widget,.collection_right .sidebar-block .widget,.collection_left .sidebar-block .widget,.filter-toggle-wrap .sidebar-block .widget,.content-right .sidebar-block .widget ").children(':nth-child(2)').css( 'display', 'none' );
    jQuery(".left-sidebar .sidebar-block .widget.active,.right-sidebar .sidebar-block .widget.active,.collection_right .sidebar-block .widget.active,.collection_left .sidebar-block .widget.active,.filter-toggle-wrap .sidebar-block .widget.active,.content-right .sidebar-block .widget.active").children(':nth-child(2)').css( 'display', 'block' );
    jQuery(".left-sidebar .sidebar-block .widget > h4.toggle,.right-sidebar .sidebar-block .widget > h4.toggle,.collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle,.content-right .sidebar-block .widget > h4.toggle").unbind("click");
    jQuery(".left-sidebar .sidebar-block .widget > h4.toggle,.right-sidebar .sidebar-block .widget > h4.toggle,.collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle,.content-right .sidebar-block .widget > h4.toggle").on('click',function() {
      jQuery(this).parent().toggleClass('active').children(':nth-child(2)').slideToggle( "fast" );
    });
    jQuery('#shopify-section-footer-style-3 .follow-us-outer').insertAfter('#shopify-section-footer-style-3 .bottom.dwld');
    jQuery('#shopify-section-footer-style-2 .bottom.dwld').insertBefore('#shopify-section-footer-style-2 .footer-bottom-content');
    jQuery('#shopify-section-footer-style-1 .bottom.dwld').insertBefore('#shopify-section-footer-style-1 .follow-us-outer');
  }else{
    jQuery('#shopify-section-footer-style-1 .bottom.dwld').insertBefore('#shopify-section-footer-style-1 .payment');
    jQuery('#shopify-section-footer-style-3 .follow-us-outer').insertAfter('#shopify-section-footer-style-3 .contact');
    jQuery('#shopify-section-footer-style-2 .bottom.dwld').insertBefore('#shopify-section-footer-style-2 .footer-top');
    if($('.left-sidebar-menu').length > 0){
      jQuery('#accessibleNav').appendTo('.nav-menu-wrapper .navbar-collapse');
    }else{
      jQuery('.ttresponsive_menu .nav-menu-wrapper').appendTo('nav#menu');
    }
    jQuery('.left-sidebar-menu').appendTo('#shopify-section-left-col-menu');
    jQuery('.left_sidebar #column-left').insertBefore('#content');
    jQuery('.sidebar .sidebar-block').insertAfter('#shopify-section-left-col-menu');
    jQuery('.collection_sidebar').prependTo('.left_column-wrap');
    jQuery('.section-header .sidebar-block').prependTo('.collection_sidebar');
    jQuery('.footer-model-3 .footer-about-wrap').prependTo('.footer-center-content');
    jQuery('.footer-model-3 .contactus').prependTo('.footer-top');
    if(jQuery('.site-footer').hasClass('fixed_footer'))  {
      var footer_h = jQuery('.site-footer.fixed_footer').height();
      jQuery('.page-wrapper').css('margin-bottom',footer_h+'px');
    }
    jQuery('.left-sidebar.sidebar,.left_sidebar .left-sidebar.sidebar').insertBefore('.collection_wrapper, .content-wrapper');
    jQuery(".left_sidebar .sidebar .widget > h4,.right_sidebar .sidebar .widget > h4,.left-sidebar.sidebar .widget > h4,.right-sidebar.sidebar .widget > h4,.sidebar-block .widget > h4,.left_sidebar .sidebar-block .widget > h4").unbind("click");
    jQuery(".left_sidebar .sidebar .widget > h4,.right_sidebar .sidebar .widget > h4,.left-sidebar.sidebar .widget > h4,.right-sidebar.sidebar .widget > h4,.sidebar-block .widget > h4,.left_sidebar .sidebar-block .widget > h4").removeClass( "toggle" );
    jQuery(".left_sidebar .sidebar .widget,.right_sidebar .sidebar .widget,.left-sidebar.sidebar .widget,.right-sidebar.sidebar .widget,.sidebar-block .widget,.left_sidebar .sidebar-block .widget").children(':nth-child(2)').css( 'display', 'block' );
    jQuery(".site-footer .widget h5").unbind("click");
    jQuery(".site-footer .widget h5").removeClass( "toggle" );
    jQuery(".site-footer .widget").children(':nth-child(2)').css( 'display', 'block' );
  }

}
jQuery(document).ready(function() {
  footerToggle();
  sidebarsticky();  
});
jQuery(window).load(function() {
  var h = $('.design_4 .product-wrapper-owlslider').height();
  $('.design_4 .product-information-inner.tt-scroll').css('min-height', h+"px");
});
jQuery(window).resize(function() {
  footerToggle();
  var h = $('.design_4 .product-wrapper-owlslider').height();
  $('.design_4 .product-information-inner.tt-scroll').css('min-height', h+"px");
});

function productcartsticky() {
  if (jQuery(window).width() > 1199) {
    if (jQuery(this).scrollTop() > 550) {
      jQuery('.add-to-cart-sticky').addClass("fixed");

    } else {
      jQuery('.add-to-cart-sticky').removeClass("fixed");
    }
  } else {
    jQuery('.add-to-cart-sticky').removeClass("fixed");
  }
}

$(document).ready(function() {
  productcartsticky();
});
jQuery(window).resize(function() {
  productcartsticky();
});
jQuery(window).scroll(function() {
  productcartsticky();
});

function splitStr(string,seperator){
  return string.split(seperator);
}

function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      countdown.countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(event.strftime('<span class="time flip"><span class="left-txt">LEFT</span><span class="ttcount next top">%D</span><span class="ttcount next bottom">%D</span><span class="time-txt">days</span></span>' + 
                                      '<span class="time flip"><span class="ttcount next top">%H</span><span class="ttcount next bottom">%H</span><span class="time-txt">hours</span></span>' + 
                                      '<span class="time flip"><span class="ttcount next top">%M</span><span class="ttcount next bottom">%M</span><span class="time-txt">min</span></span>' + 
                                      '<span class="time flip"><span class="second ttcount next top">%S</span><span class="second ttcount next bottom">%S</span><span class="second time-txt">sec</span></span>'));
      });
    }

  });
}

function hb_animated_contents() {
  $(".hb-animate-element:in-viewport").each(function (i) {
    var $this = $(this);
    if (!$this.hasClass('hb-in-viewport')) {
      setTimeout(function () {
        $this.addClass('hb-in-viewport');
      }, 180 * i);
    }
  });
}

$(window).scroll(function () {
  hb_animated_contents();
});
$(window).load(function () {
  hb_animated_contents();
});



function sidebarsticky() { 
  if ($(document).width() >= 992 && $(document).width() <= 1199) {
    jQuery('.left_sidebar #left-column,#column-left,.content-left,.content-right,.right_sidebar #right-column,#column-right,.content-left,.collection_right,.collection_left,.both_sidebar #right-column,.left-sidebar.sidebar,.right-sidebar.sidebar').theiaStickySidebar({
      additionalMarginBottom: 30,
      additionalMarginTop: 30
    });
  } 
  else if ($(document).width() >= 1200) {
    jQuery('.left_sidebar #left-column,#column-left,.content-left,.content-right,.right_sidebar #right-column,#column-right,.content-left ,.collection_right,.collection_left,.both_sidebar #right-column,.left-sidebar.sidebar,.right-sidebar.sidebar').theiaStickySidebar({
      additionalMarginBottom: 30,
      additionalMarginTop: 130
    });
  }
}
jQuery(window).resize(function() {
  sidebarsticky();
});
/* responsive accordian menu*/
$(function() {
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    // Variables privadas
    var links = this.el.find('.mobile-nav__sublist-trigger');
    // Evento
    links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
  }

  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
    $this = $(this),
      $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('open');

    if (!e.data.multiple) {
      $el.find('.tt_sub_menu_wrap').not($next).slideUp().parent().removeClass('open');
    };
  }	

  var accordion = new Accordion($('.tt_menus_ul'), false);
});
$(function() {
  var Accordions = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    // Variables privadas
    var link = this.el.find('.toggle');
    // Evento
    link.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
  }

  Accordions.prototype.dropdown = function(e) {
    var $el = e.data.el;
    $this = $(this),
      $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('active');

    if (!e.data.multiple) {
      $el.find('.inline-list').not($next).slideUp().parent().removeClass('active');
    };
  }	

  var accordions = new Accordions($('.footer-column'), false);

});
